export const toggleSidebar = () => {
  console.log("here");
  var element = document.getElementById("sidebar-container");
  if (element.classList.contains("active__1")) {
    element.classList.remove("active__1");
  } else {
    element.classList.add("active__1");
  }
};
